import {createElement, Component, PropTypes} from 'rlink-react';
import contentLoader from 'helpers/content-loader';
import {FormattedMessage} from 'react-intl';

import {ContentImg} from 'rlink-repos/content-components';
import {NavLink} from 'rlink-router/component';

import Region from 'rlink-regions/Region';

export default class Footer extends Component {
  get ratingsBoardLinks () {
    if ('data' in this.props.globalSettings && this.props.globalSettings.data.has('defaultRatingsBoard')) {
      let ratingsBoard = Region.fromString(this.props.region).ratingsBoard;
      let defaultRatingsBoard = this.props.globalSettings.defaultRatingsBoard;
      let footerRatingsBoards = this.props.globalSettings.footerRatingsBoards;
      if (footerRatingsBoards.has(ratingsBoard)) {
        let regionRatingBoards = footerRatingsBoards.get(ratingsBoard);
        let hasValidImagePaths = regionRatingBoards.every(board => board.get('imagePath') !== null);
        if (hasValidImagePaths) {
          return regionRatingBoards;
        }
      }
      return footerRatingsBoards.get(defaultRatingsBoard);
    }
  }

  render () {
    return (
      <footer className={this.props.css.footer}>
        <div className={this.props.css['panel-content']}>
          <div className={this.props.css['footer-top']}>
            <ul className={this.props.css['footer-links']}>
              <li><a target="_blank" rel="noopener" href={this.props.links.support}>
                <FormattedMessage
                  id="ui.label.link.FOOTER_SUPPORT"
                  defaultMessage="Support"
                  description="Link appearing in the main Dawn of War site footer linking to Relic support." />
              </a></li>

              <li><a target="_blank" rel="noopener" href={this.props.links.careers}>
                <FormattedMessage
                  id="ui.label.link.FOOTER_CAREERS"
                  defaultMessage="Careers"
                  description="Link appearing in the main Dawn of War site footer linking to our careers page." />
              </a></li>
            </ul>
            <ul className={this.props.css['footer-logos']}>
              <li><a target="_blank" href={this.props.links.relic}><img src={contentLoader('relic-footer-logo.png')} /></a></li>
              <li><a target="_blank" href={this.props.links['wh40k']}><img className={this.props.css["games-workshop"]} src={contentLoader("40k_logo.png")}/></a></li>
              <li><a target="_blank" href={this.props.links.games_workshop}><img className={this.props.css['games-workshop']} src={contentLoader('Gwlogo.png')} /></a></li>
            </ul>
        </div>
          <hr />
          <div className={this.props.css['footer-terms']}>
            <p>
              <FormattedMessage
                id="ui.text.description.FOOTER_COPYRIGHT"
                defaultMessage="Warhammer 40,000: Dawn of War III © Copyright Games Workshop Limited {YEAR}. Dawn of War III, the Dawn of War logo, GW, Games Workshop, Space Marine, 40K, Warhammer, Warhammer 40,000, 40,000, the ‘Aquila’ Double-headed Eagle logo, and all associated logos, illustrations, images, names, creatures, races, vehicles, locations, weapons, characters, and the distinctive likeness thereof, are either ® or TM, and/or © Games Workshop Limited, variably registered around the world, and used under license. Developed by Relic Entertainment . Relic Entertainment and the Relic Entertainment logo are either registered trademarks or trademarks of Relic Holdings Co., Ltd or its affiliates. All rights reserved. All other trademarks, logos and copyrights are the property of their respective owners."
                description="Copyright notice appearing in the main Dawn of War site footer."
                values={{
                  YEAR: new Date().getFullYear(),
                }} />
            </p>
            {
              (this.props.esrbDetails && this.props.esrbDetails.reasons)
              ? <NavLink href={{
                  view: 'legal',
                  params: {},
                  returnTransition: 'fade',
                  transition: 'fade',
                }}>
                <FormattedMessage
                  id="ui.label.link.FOOTER_COPYRIGHT_READ_MORE"
                  defaultMessage="For other legal notices, please click here"
                  description="Link appearing in the main Dawn of War site footer linking to our legal notices page." />
                </NavLink>
              : null
            }
          </div>
        <hr />
          <div className={this.props.css['footer-bottom']}>
            <ul className={this.props.css.regulatory}>
              {this.ratingsBoardLinks && this.ratingsBoardLinks.map((imageLink, idx) =>
                <li key={idx}>
                  <a target="_blank" href={imageLink.get('link')}>
                    <div>
                      <ContentImg src={imageLink.get('imagePath')} />
                    </div>
                  </a>
                </li>
              )}
            </ul>
            <ul className={this.props.css.legal}>
              <li><a target="_blank" href={this.props.links.cp}>Cookie Policy</a></li>
              <li><a target="_blank" rel="noopener" href={this.props.links.tos}>
                <FormattedMessage
                  id="ui.label.link.FOOTER_TERMS_OF_SERVICE"
                  defaultMessage="Terms & Conditions"
                  description="Link appearing in the main Dawn of War site footer linking to our terms and conditions." />
              </a></li>
              <li><a target="_blank" rel="noopener" href={this.props.links.pp}>
                <FormattedMessage
                  id="ui.label.link.FOOTER_PRIVACY_POLICY"
                  defaultMessage="Privacy Policy"
                  description="Link appearing in the main Dawn of War site footer linking to our privacy policy." />
              </a></li>
              <li><a target="_blank" rel="noopener" href={this.props.links.eula}>
                <FormattedMessage
                  id="ui.label.link.FOOTER_EULA"
                  defaultMessage="EULA"
                  description="Link appearing in the main Dawn of War site footer linking to our End User License Agreement." />
              </a></li>
            </ul>
          </div>
        </div>
      </footer>);
  }
}

Footer.propTypes = {
  links: PropTypes.object,
  region: PropTypes.string,
  globalSettings: PropTypes.object,
  css: PropTypes.object,
};

Footer.defaultProps = {
  className: '',
  links: {
    support: 'https://help.relic.com/hc/en-us',
    careers: 'https://www.relic.com/#careers',
    tos: 'https://content.relic.com/legal/eula_terms.html',
    pp: 'https://content.relic.com/legal/privacypolicy.html',
    cp: 'https://content.relic.com/legal/cookiepolicy.html',
    eula: 'https://content.relic.com/legal/eula_terms.html',
    esrb: 'http://esrb.org/',
    esrb_pc: 'http://www.esrb.org/confirm/sega-confirmation.aspx',
    relic: 'http://www.relic.com/',
    sega: 'http://www.sega.com',
    games_workshop: 'https://www.games-workshop.com/Home?_requestid=10810861',
    wh40k: 'https://warhammer40000.com/',
  },
};



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/footer.jsx